import { NgModule } from "@angular/core";
import { ProjectListModule } from "./features/list/project-list.module";
import { ProjectsComponent } from "./projects.component";
import { ProjectsRoutingModule } from "./projects.routing";
@NgModule({
    declarations: [ProjectsComponent],
    imports: [ProjectsRoutingModule, ProjectListModule],
})
export class ProjectsModule {}
